export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_05.723044fd.jpg";